import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, ChapterTag } from "./Reveal";

const FAQS = [
  {
    q: "How can I exchange USDT to INR?",
    a: "Download the Coin Adda app, create your account, deposit USDT and place your exchange. Once processed, the INR amount is sent to your linked bank account.",
  },
  {
    q: "How do I deposit USDT?",
    a: "Open the app and go to the deposit section to see your personal USDT deposit address. Transfer USDT to that address and it will be credited after the required network confirmations.",
  },
  {
    q: "How do I receive INR?",
    a: "After your exchange is completed, the INR amount is paid out to your linked bank account through the app's withdrawal flow. You can track the status inside the app.",
  },
  {
    q: "Which network is supported?",
    a: "The app currently supports USDT deposits on the TRC20 network. Always confirm the supported network on the deposit screen inside the app before sending any funds.",
  },
  {
    q: "Where can I download the Coin Adda app?",
    a: "Right here — tap any “Download App” button on this page and the Android APK will download directly to your phone. Then open the file to install and start exchanging.",
  },
  {
    q: "How can I contact support?",
    a: "Use the Contact Support option inside the Coin Adda app. Our support team can help with deposits, exchanges, withdrawals and account questions.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative border-t border-white/5 py-24 sm:py-32">
      <div className="mx-auto max-w-4xl px-5 sm:px-8">
        <Reveal>
          <ChapterTag index="06" label="FAQ" />
          <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tighter text-slate-50 sm:text-5xl">
            Questions, <span className="text-[#00F5A0]">Answered</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-12" data-testid="faq-accordion">
            {FAQS.map((faq, i) => (
              <AccordionItem
                key={faq.q}
                value={`item-${i}`}
                className="border-white/10"
                data-testid={`faq-item-${i + 1}`}
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i + 1}`}
                  className="text-left font-display text-base font-semibold text-slate-100 hover:text-[#00F5A0] hover:no-underline sm:text-lg"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i + 1}`}
                  className="text-sm leading-relaxed text-slate-400 sm:text-base"
                >
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
